import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink, FiChevronDown, FiChevronUp, FiGlobe } = FiIcons;

const ExternalSourcesPanel = ({ query, searchUrls }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!query || Object.keys(searchUrls).length === 0) {
    return null;
  }

  const urlEntries = Object.entries(searchUrls);
  const totalSources = urlEntries.length;
  const visibleSources = isExpanded ? urlEntries : urlEntries.slice(0, 12);

  return (
    <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900 dark:to-indigo-900 rounded-xl border border-blue-200 dark:border-blue-700">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <SafeIcon icon={FiGlobe} className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          <h3 className="text-sm font-semibold text-blue-900 dark:text-blue-100">
            Buscar también en las {totalSources} fuentes externas:
          </h3>
        </div>
        {totalSources > 12 && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-center space-x-1 px-3 py-1 bg-blue-100 dark:bg-blue-800 text-blue-700 dark:text-blue-200 rounded-lg text-xs hover:bg-blue-200 dark:hover:bg-blue-700 transition-colors"
          >
            <span>{isExpanded ? 'Ver menos' : `Ver todas (${totalSources})`}</span>
            <SafeIcon icon={isExpanded ? FiChevronUp : FiChevronDown} className="w-3 h-3" />
          </button>
        )}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={isExpanded ? 'expanded' : 'collapsed'}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2"
        >
          {visibleSources.map(([key, source]) => (
            <motion.a
              key={key}
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center space-x-1 px-2 py-2 bg-white dark:bg-blue-800 text-blue-800 dark:text-blue-200 rounded-lg text-xs hover:bg-blue-50 dark:hover:bg-blue-700 transition-all duration-200 text-center min-h-[2.5rem] group border border-blue-200 dark:border-blue-600 shadow-sm hover:shadow-md"
              title={`Buscar "${query}" en ${source.name}`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span className="truncate text-xs font-medium">{source.name}</span>
              <SafeIcon icon={FiExternalLink} className="w-3 h-3 flex-shrink-0 opacity-60 group-hover:opacity-100" />
            </motion.a>
          ))}
        </motion.div>
      </AnimatePresence>

      <div className="mt-4 p-3 bg-blue-100 dark:bg-blue-800 rounded-lg">
        <div className="flex items-start space-x-2">
          <span className="text-blue-600 dark:text-blue-300 text-sm">💡</span>
          <div className="text-xs text-blue-700 dark:text-blue-300">
            <p className="font-medium mb-1">Búsqueda personalizada por fuente:</p>
            <p>
              Cada enlace te llevará directamente a buscar <strong>"{query}"</strong> en esa fuente específica. 
              Los parámetros de búsqueda están optimizados para cada base de datos académica.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExternalSourcesPanel;